<template>
  <Modal v-if="memo.show" :loading="memo.busy" :title="title" @close="close">
    <template #content>
      <div class="memo-container">
        <div class="count">
          <span :class="{ isOver }">{{ count }}</span> / 1000
        </div>
        <TextArea
          class="textarea"
          :value="contents"
          placeholder="例）本日店長不在です。"
          @input="onInput"
          noneAutosize
        />
      </div>
    </template>
    <template #footer-center>
      <Button @click="close">キャンセル</Button>
      <Button primary :disabled="isOver" @click="save">保存</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils/date'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import TextArea from '@/components/atoms/TextArea'

export default {
  name: 'MemoModal',
  components: {
    Modal,
    Button,
    TextArea,
  },
  computed: {
    ...mapState({
      memo: 'memo',
    }),
    title() {
      return `${formatDate(this.memo.date, 'M/D (dd)')}のメモ`
    },
    contents() {
      return this.memo.contents ? this.memo.contents : ''
    },
    count() {
      return this.contents.length
    },
    isOver() {
      return this.count > 1000
    },
  },
  methods: {
    onInput(value) {
      this.$store.commit('memo/update', { date: this.memo.date, contents: value })
    },
    async save() {
      await this.$store.dispatch('memo/save')
      this.close()
    },
    close() {
      this.$store.commit('memo/reset')
      this.$store.commit('memo/show', false)
    },
  },
}
</script>

<style lang="postcss" scoped>
.memo-container {
  display: grid;
  padding: 32px 16px;

  .responsive & {
    @media screen and (--sp-modal) {
      background-color: var(--mostly-white);
      box-sizing: border-box;
      grid-template-rows: max-content 1fr;
      height: 100%;
      padding: 16px;
    }
  }
}

.count {
  padding-bottom: 11px;
  text-align: right;

  .isOver {
    color: var(--pure-red);
  }

  .responsive & {
    @media screen and (--sp-modal) {
      padding-bottom: 6px;
    }
  }
}

.textarea {
  height: 144px;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;

  .responsive & {
    @media screen and (--sp-modal) {
      height: 100%;
      padding: 20px 16px;
      resize: none;
    }
  }
}
</style>
